export const QUERY_KEYS = {
  useGetUpcomingSendsKey: 'useGetUpcomingSendsKey',
  useGetOrganizationUsers: 'useGetOrganizationUsers',
  useGetOrganizationUserCount: 'useGetOrganizationUserCount',
  useGetRecognitionKey: 'useGetRecognitionKey',
  useGetRecognitionsKey: 'useGetRecognitionsKey',
  useGetRecognitionProductsKey: 'useGetRecognitionProductsKey',
  useGetAutomationKey: 'useGetAutomationKey',
  useGetAutomationProductsKey: 'useGetAutomationProductsKey',
  useGetRecognitionsApprovalKey: 'useGetRecognitionsApprovalKey',
  useGetAutomationApprovalKey: 'useGetAutomationApprovalKey',
  useGetContactKey: 'useGetContactKey',
  useGetContactsKey: 'useGetContactsKey',
  useGetTagListKey: 'useGetTagListKey',
  useGetAllContactIdsKey: 'useGetAllContactIdsKey',
  useGetLLMSuggestionsGiftMessageKey: 'useGetLLMSuggestionsGiftMessageKey',
  useGetLLMSuggestionsProductFiltersKey: 'useGetLLMSuggestionsProductFiltersKey',
  useGetAllTagIdsKey: 'useGetAllTagIdsKey',
  useGetSelectionKey: 'useGetSelectionKey',
  useGetCategoriesKey: 'useGetCategoriesKey',
  useGetPublicEntitiesKey: 'useGetPublicEntitiesKey',
  useGetHomeTopCategoriesKey: 'useGetHomeTopCategoriesKey',
  useGetCollectionKey: 'useGetCollectionKey',
  useGetCollectionProductsKey: 'useGetCollectionProductsKey',
  useGetCollectionsKey: 'useGetCollectionsKey',
  useGetUserKey: 'useGetUserKey',
  useGetOrganizationUserKey: 'useGetOrganizationUserKey',
  useGetProductsKey: 'useGetProductsKey',
  useGetProductDetailKey: 'useGetProductDetailKey',
  useGetProductsByCodesKey: 'useGetProductsByCodesKey',
  useGetProductSkusKey: 'useGetProductSkusKey',
  useGetInfiniteProductsKey: 'useGetInfiniteProductsKey',
  useGetAutomationOrders: 'useGetAutomationOrders',
  useGetGraphDataKey: 'useGetGraphDataKey',
  useGetRecognitionSpendingSummaryKey: 'useGetRecognitionSpendingSummaryKey'
};

export const STALE_TIME = {
  useGetProducts: 60 * 1000,
  useGetGraphData: 10 * 60 * 1000
};
